var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLedger = function SvgLedger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 29.34v6.876h10.464v-1.525h-8.94v-5.35H10Zm26.294 0v5.351h-8.94v1.525h10.464V29.34h-1.524ZM20.479 18.876V29.34h6.876v-1.375h-5.352v-9.089H20.48ZM10 12v6.876h1.525v-5.351h8.939V12H10Zm17.355 0v1.525h8.939v5.351h1.524V12H27.355Z"
  })));
};
export default SvgLedger;